export default __webpack_public_path__ + "static/media/user.3b5e7f7e.svg";